export default __webpack_public_path__ + "static/media/trainings-course.ee67fcf4.svg";